// Open the help sheet or the feedback form from anywhere (top bar "?", Settings, crash screen, help articles).
import { track } from '@/lib/analytics';

declare const __APP_BUILD__: string;
export const APP_BUILD = typeof __APP_BUILD__ === 'string' ? __APP_BUILD__ : 'dev';

export type HelpView = 'help' | 'feedback';
const EVENT = 'bp:help';

export function openHelp(source: string) {
  track('help_open', { source, path: location.pathname }, 'help');
  dispatchEvent(new CustomEvent(EVENT, { detail: { view: 'help', source } }));
}

export function openFeedback(source: string) {
  track('feedback_open', { source, path: location.pathname }, 'help');
  dispatchEvent(new CustomEvent(EVENT, { detail: { view: 'feedback', source } }));
}

export function onHelpRequest(fn: (view: HelpView, source: string) => void) {
  const h = (e: Event) => { const d = (e as CustomEvent<{ view: HelpView; source: string }>).detail; fn(d.view, d.source); };
  addEventListener(EVENT, h);
  return () => removeEventListener(EVENT, h);
}
